import { DataType } from './data-type.model';

export class Catalog {
    genders: DataType[];
    races: DataType[];
    ethnicities: DataType[];
}